export default "__VITE_ASSET__CvAShJAk__"